import * as css from 'css/exports.module.scss';
import { AsyncStateNotification } from '@ui/notifications';
import { getDirectParent } from '@lib/popups';
import { SonarCard } from '@ui/general';
import { TagDescriptionInput } from './TagDescriptionInput';
import { TagNameInput } from './TagNameInput';
import { TagOwnersInput } from './TagOwnersInput';
import { useCreateTag } from '@hooks';
import { Button, Col, Form, Row } from 'antd';
import { COPY_SPECIFIC, NOTIFICATIONS_COPY, TAG_COLORS } from '@sonar-software/sonar-ts-constants';
import React, { useEffect, useRef, useState } from 'react';
export const CreateTag = () => {
    const [hexColor, setHexColor] = useState(TAG_COLORS[0]);
    const formRef = useRef(null);
    const { isProcessing, isSuccessful, request, reset } = useCreateTag();
    const handleOnSubmit = (values) => {
        const { description, name, userIds } = values;
        const ownerIds = (userIds === null || userIds === void 0 ? void 0 : userIds.length) ? userIds.map(Number) : [];
        request({
            description: description !== null && description !== void 0 ? description : '',
            hexColor,
            name,
            ownerIds
        });
    };
    useEffect(() => {
        var _a;
        if (isSuccessful) {
            (_a = formRef.current) === null || _a === void 0 ? void 0 : _a.resetFields();
            setHexColor(TAG_COLORS[0]);
        }
    }, [isSuccessful]);
    return (React.createElement(React.Fragment, null,
        React.createElement(SonarCard, { className: 'tag-create-card', title: COPY_SPECIFIC.CREATE_TAG },
            React.createElement(Form, { className: 'create', onFinish: handleOnSubmit, ref: formRef },
                React.createElement(Row, { gutter: [Number(css.size16), 0] },
                    React.createElement(Col, { span: 6 },
                        React.createElement(TagNameInput, { getPopupContainer: getDirectParent, hexColor: hexColor, name: 'name', onColorClick: setHexColor })),
                    React.createElement(Col, { span: 18 },
                        React.createElement(TagOwnersInput, { name: 'userIds' }))),
                React.createElement(TagDescriptionInput, { name: 'description' }),
                React.createElement(Row, null,
                    React.createElement(Button, { className: 'tag-create-button', disabled: isProcessing, htmlType: 'submit', id: 'tag-create-button', loading: isProcessing, type: 'primary' }, COPY_SPECIFIC.CREATE)))),
        React.createElement(AsyncStateNotification, { errored: NOTIFICATIONS_COPY.ERROR_POST_TAG, failed: NOTIFICATIONS_COPY.FAILED_POST_TAG, received: NOTIFICATIONS_COPY.SUCCESS_POST_TAG, resetAction: reset, stateSelector: useCreateTag.selectors.state })));
};
